/**
 * Utilidades de texto compartidas por las pantallas del Catálogo v2.
 *
 * Están aquí y no duplicadas en cada componente por un motivo concreto: el
 * regex de acentos usa un rango de caracteres combinantes que, escrito con
 * los caracteres literales, es invisible en el código fuente y cualquier
 * editor o cambio de codificación lo destroza sin dejar rastro. Con una sola
 * copia y las secuencias de escape explícitas, eso no puede pasar.
 */

/**
 * Quita los acentos para comparar.
 *
 * La búsqueda del servidor usa la intercalación de SQL Server, insensible a
 * acentos: "cirugia" encuentra "Cirugía". El `includes` de JavaScript no.
 * Sin esto, el filtrado en cliente se comportaría distinto que el del
 * servidor dentro de la misma caja de búsqueda.
 */
export const sinAcentos = (texto) =>
  (texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

/**
 * Mismo saneado de nombre que usa el catálogo antiguo para construir la URL:
 * quita los paréntesis y su contenido.
 */
export const limpiarNombre = (nombre) => (nombre || '').replace(/ *\([^)]*\) */g, '')

/** Segmento de URL para el nombre de una família. */
export const segmentoNombre = (nombre) => encodeURIComponent(limpiarNombre(nombre))
